/**
 * Everflow, `/postbacks/everflow`. Generic PostbackQueryDto. Backoffice, TMA
 * and Telegram agree on this template verbatim.
 */
export const everflowContract = {
    id: 'everflow',
    displayName: 'Everflow',
    route: 'everflow',
    trackingTagMacro: '{transaction_id}',
    amountBehavior: 'FTD/CPA amount comes from {payout}; REDEP amount comes from {amount} — a different macro. currency ' +
        'is not an Everflow macro; CPA hardcodes EUR.',
    duplicateParamPolicy: 'array-then-tolerant-last-wins',
    caseSensitiveParams: [],
    requiresFixedCurrencyForCpa: true,
    pitfalls: [],
    sourceRefs: ['apps/api/src/modules/postbacks/controllers/postbacks.controller.ts:261-297'],
    events: [
        {
            event: 'REG',
            eventValue: 'registration',
            params: [
                { ourParam: 'uid', macro: '{transaction_id}' },
                { ourParam: 'subid', macro: '{offer_id}' },
                { ourParam: 'tracking_tag', macro: '{transaction_id}' },
            ],
        },
        {
            event: 'FTD',
            eventValue: 'ftd',
            params: [
                { ourParam: 'uid', macro: '{transaction_id}' },
                { ourParam: 'subid', macro: '{offer_id}' },
                { ourParam: 'amount', macro: '{payout}' },
                { ourParam: 'tracking_tag', macro: '{transaction_id}' },
            ],
        },
        {
            event: 'QUALIFIED_CPA',
            eventValue: 'cpa',
            params: [
                { ourParam: 'uid', macro: '{transaction_id}' },
                { ourParam: 'subid', macro: '{offer_id}' },
                { ourParam: 'amount', macro: '{payout}' },
                { ourParam: 'currency', macro: 'EUR' },
                { ourParam: 'tracking_tag', macro: '{transaction_id}' },
            ],
            fixedParams: { currency: 'EUR' },
        },
        {
            event: 'REDEP',
            eventValue: 'redep',
            params: [
                { ourParam: 'uid', macro: '{transaction_id}' },
                { ourParam: 'subid', macro: '{offer_id}' },
                { ourParam: 'amount', macro: '{amount}' },
                { ourParam: 'tracking_tag', macro: '{transaction_id}' },
            ],
        },
    ],
};
//# sourceMappingURL=everflow.js.map